/**
 * Require confirmation block for ConfirmModal.
 * Extracted to keep ConfirmModal under max-lines-per-function.
 */

import React, { ChangeEvent } from "react";
import TextField from "../../Form/TextField";
import Typography, { ETypo, ETypoColor } from "../../Typography";
import blocks from "./confirmModalBlocks.module.scss";

export type RequireConfirmationProps = {
	enabled: boolean;
	label: string;
	placeholder: string;
	expectedValue: string;
	confirmationValue: string;
	onConfirmationChange: (event: ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void;
};

export function ConfirmModalRequireConfirmationBlock(props: RequireConfirmationProps): React.JSX.Element | null {
	const { enabled, label, placeholder, expectedValue, confirmationValue, onConfirmationChange } = props;
	if (!enabled) {
		return null;
	}

	const hasValidExpectedValue =
		typeof expectedValue === "string" && expectedValue.trim().length > 0;

	return (
		<div className={blocks["confirmationBlock"]}>
			{hasValidExpectedValue ? (
				<>
					<Typography typo={ETypo.TEXT_SM_SEMIBOLD} color={ETypoColor.TEXT_PRIMARY}>
						Pour confirmer, saisissez :
					</Typography>
					<div className={blocks["expectedValue"]}>
						<Typography typo={ETypo.TEXT_LG_BOLD} color={ETypoColor.COLOR_PRIMARY_500}>
							{expectedValue}
						</Typography>
					</div>
					<TextField
						name="confirmation"
						label={label}
						placeholder={placeholder}
						value={confirmationValue}
						onChange={onConfirmationChange}
						required
					/>
				</>
			) : (
				<Typography typo={ETypo.TEXT_SM_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
					La valeur à saisir n&apos;est pas disponible. Actualisez la page puis réessayez.
				</Typography>
			)}
		</div>
	);
}
